/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  UpdateAffiliateProgramOptions,
  UpdateAffiliateProgramResponses,
} from '../types/UpdateAffiliateProgram'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description ADMIN or INTEGRATOR required. Integrators are restricted to their own tenant; ADMIN overrides other roles. Omitted and null fields are preserved. Fields accept direct values or {update, value} objects. Tenant ownership cannot be changed. Deactivation preserves codes and registrations.
 * @summary Update an affiliate program
 * {@link /v1/affiliate_programs/:program_id}
 */
export function updateAffiliateProgram<ThrowOnError extends boolean = true>(
  options: Options<UpdateAffiliateProgramOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateAffiliateProgramResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/affiliate_programs/{program_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateAffiliateProgramResponses, ThrowOnError>>,
  )
}
